import createAction from '../../../utils/redux-helpers/createAction';

const handler = (state, { name }) => state.setIn(['modals', name], false);

export const closeModal = createAction({
  action: ['closeModal', 'name'],
  handler,
});
